import { render, staticRenderFns } from "./dashboardAftercare.vue?vue&type=template&id=47f3c4fc&scoped=true"
import script from "./dashboardAftercare.vue?vue&type=script&lang=js"
export * from "./dashboardAftercare.vue?vue&type=script&lang=js"
import style0 from "./dashboardAftercare.vue?vue&type=style&index=0&id=47f3c4fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f3c4fc",
  null
  
)

export default component.exports